import { useEffect, type ReactNode } from "react";
import { useAuthStore } from "../stores/authStore";

// StrictMode runs the effect twice. One restore is enough.
let started = false;

export function resetAuthProviderForTests(): void {
  started = false;
}

export function AuthProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    if (started) return;
    started = true;
    void useAuthStore.getState().bootstrap();
  }, []);
  return children;
}
